// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"88":"724cd00f851184189429","335":"5c0c3f8753a6c8579f7a","373":"86d554a7191746c56936","550":"ba2e0982ce6af104d578","681":"775e2e3dceec68805181","807":"28c1e14baa8815545925","824":"13b19a643b6e31eb8a86","921":"921c4b2bd5c67105e4a5"}[chunkId] + ".bundle.js";
};